import * as React from 'react'
import { useState } from 'react'
import { useTransition, animated } from 'react-spring'
import { ToggleButton } from '../../shared/ToggleButton'

export const MobileFooterSectionWrapper = ({ title, children }: {title: string, children: React.ReactNode}) => {
    const [sectionOpen, setSectionOpen] = useState(false)

    const slideOpen = useTransition(sectionOpen, {
        from: {
            opacity: 0.5,
            maxHeight: 0,
        },
        enter: { opacity: 1, maxHeight: 1000 },
        leave: { opacity: 0, maxHeight: 0 },
        reverse: sectionOpen,
        config: { duration: 200 },
        delay: 0,
    })

    return (
        <div className="footer--section mobile">
            <div className="row">
                <div className="col col--is--11 h5">{title}</div>
                <div className="col col--is--1">
                    <ToggleButton
                        onClick={() => setSectionOpen((prev) => !prev)}
                        isOpen={sectionOpen}
                    />
                </div>
            </div>
            {slideOpen(
                (styles, item) =>
                    item && (
                        <animated.div style={styles} className="footer--list">{children}</animated.div>
                    )
            )}
        </div>
    )
}
